import React, { useEffect, useState } from 'react'
import { BiTimeFive } from 'react-icons/bi'

const Deadline = ({deadline} : any) => {
  const [deadlineColor, setDeadlineColor] = useState('#529839')

  useEffect(() => {
    const today = Date.now()
    const parsedDeadline = Date.parse(deadline)
    const oneDay = 1000 * 60 * 60 * 24

    const differenceInDays = Math.ceil((parsedDeadline - today) / oneDay)

    if (differenceInDays === 0) {
      setDeadlineColor('#E3B664') // yellow
    } else if (differenceInDays < 0) {
      setDeadlineColor('#E46565') // green
    } else {
      setDeadlineColor('#58B153')// red
    }

  }, [deadline])

  return (
    <div className='todo_item__deadline' style={{backgroundColor: deadlineColor}}>
        <BiTimeFive />
        <p>{deadline}</p>
    </div>
  )
}

export default Deadline